document.addEventListener("DOMContentLoaded", () => {
    const slider = document.querySelectorAll('.slide-ins > div > input');

    if (!slider) return;

    document.addEventListener('click', (e) => {
        slider.forEach(el => {
            if (el.parentElement.classList.contains('start-open')) {
                el.checked = false;
                navi.classList.remove('start-open')
                return;
            }
            if (el === e.target || el.nextElementSibling === e.target || el.nextElementSibling?.firstChild === e.target) {
                e.preventDefault();
                el.checked = !el.checked;
            } else {
                el.checked = false;
            }
        })
    })

    const navi = document.querySelector('.start-open')

    if (!navi) return;

    const closeNavi = () => {
        setTimeout(() => navi.classList.remove('start-open'), 100);
        document.removeEventListener('click', closeNavi);
        document.removeEventListener('scroll', closeNavi);
        navi.removeEventListener('mouseenter', closeNavi);
        clearTimeout(naviTimeout);
    }

    document.addEventListener('click', closeNavi);
    document.addEventListener('scroll', closeNavi);
    navi.addEventListener('mouseenter', closeNavi);
    const naviTimeout = setTimeout(closeNavi, 4000);
})